import React, { useEffect, useState } from "react";
import { Phone, Calendar, ArrowUp } from "lucide-react";
import { siteInfo } from "../../mock";

const FloatingActions = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="fixed right-4 bottom-4 z-50 flex flex-col gap-3">
      <a
        href={`tel:${siteInfo.phoneRaw}`}
        className="md:hidden w-12 h-12 rounded-full bg-gradient-to-b from-[#B79A68] to-[#8D7448] text-[#ffffff] flex items-center justify-center shadow-lg"
        aria-label="Call"
      >
        <Phone size={20} />
      </a>
      <a
        href="#contact"
        className="md:hidden w-12 h-12 rounded-full bg-[#ffffff] border border-[#B79A68] text-[#7D6A42] flex items-center justify-center shadow-lg"
        aria-label="Appointment"
      >
        <Calendar size={20} />
      </a>
      {show && (
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="w-12 h-12 rounded-full bg-[#FBF8F1] border border-[#B79A68] text-[#7D6A42] flex items-center justify-center shadow-lg hover:bg-[#B79A68] hover:text-[#ffffff] transition-colors"
          aria-label="Back to top"
        >
          <ArrowUp size={20} />
        </button>
      )}
    </div>
  );
};

export default FloatingActions;
